import React, { useState } from "react";
import { useKeyboardShortcuts } from "./useKeyboardShortcuts";
import ShortcutHelpOverlay from "./ShortcutHelpOverlay";

const ShortcutManager = () => {
  const [helpOpen, setHelpOpen] = useState(false);

  // Initialize the shortcut listener hook
  useKeyboardShortcuts(setHelpOpen);

  return (
    <ShortcutHelpOverlay open={helpOpen} onClose={() => setHelpOpen(false)} />
  );
};

export default ShortcutManager;
